module.exports = __webpack_public_path__ + "img/api-logo-headpic.05bb339f.png";